import { tWithKeyAttr as t } from "../../i18nHelper";
import React from 'react';
import styles from './riskStatusBar.module.css';
import warningIcon from '../../images/warning_icom.svg';

interface RiskStatusBarProps {
    percentage: number; // 0 to 100
}

type TRiskLevelInfo = {
    label: string;
    background: string;
    color: string;
};

// 0-39% low, 40-69% medium, 70-100% high.
// The same boundaries are drawn as zones on the track, see .barContainer in the css.
const getRiskLevel = (percentage: number): TRiskLevelInfo => {
    if (percentage >= 70) {
        return { label: t('HIGH'), background: 'rgb(255,0,0)', color: 'white' };
    }
    if (percentage >= 40) {
        return { label: t('MEDIUM'), background: 'rgb(255,120,0)', color: 'white' };
    }
    return { label: t('LOW'), background: 'rgb(255,200,0)', color: '#333333' };
};

const RiskStatusBar: React.FC<RiskStatusBarProps> = ({ percentage }) => {

    if (!Number.isFinite(percentage)) {
        return null;
    }

    // Round once, before classifying, so the bar, the level and the printed number can never disagree.
    const value = Math.round(Math.min(100, Math.max(0, percentage)));
    const risk = getRiskLevel(value);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                    <img alt="" src={warningIcon} className={styles.icon} style={{ backgroundColor: risk.background }}/>
                    <span className={styles.title}>{t('RISK_STATUS')}</span>
            </div>

            <div
                dir='ltr'
                className={styles.barContainer}
                role='progressbar'
                aria-valuenow={value}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={t('RISK_STATUS')}
            >
                <div
                    className={styles.filled}
                    style={{ width: `${value}%`, backgroundColor: risk.background }}
                />
            </div>

            <div dir='ltr' className={styles.labels}>
                <span>{"0% "}{t('WITHOUT_RISK')}</span>
                <span>{t('HIGH_RISK_100_PERCENT')}</span>
            </div>

            <div className={styles.summary} style={{ backgroundColor: risk.background, color: risk.color }}>
                {t('RISK')} {risk.label} - {value}%
            </div>
        </div>
    );
};

export default RiskStatusBar;
